module.exports = __webpack_public_path__ + "img/play.469a4baf.svg";